export const organizationSitesKeys = {
  all: ["organization-sites"] as const,
  lists: () => [...organizationSitesKeys.all, "list"] as const,
  list: () => [...organizationSitesKeys.lists()] as const,
};
